module.exports = __webpack_public_path__ + "img/img-i5gam-cpinfo3.9e968cd4.png";